<rk-dropdown
  [options]="fontFamilyOptions"
  [selectedOption]="selectedFont"
  (selectionChange)="onFontSelectionChange($event)"
  [fullWidth]="true"
>
</rk-dropdown>
